<template>
  <div :class="$attrs.class">
    <label class="top-label">COMPLETE PROFILE: STEP 4 OF 4</label>

    <h1>Document Upload</h1>

    <p>
      Please select an image, PDF, DOC, or DOCX file for each input
      below.
    </p>

    <form-component>
      <form id="documents"
        data-vv-scope="documents"
        @submit.prevent="submit"
      >
        <government-id required v-model="governmentId" />
        <insurance required v-model="insurance" />

        <div class="form__input">
          <label> Counseling License Details </label>
        </div>
        <license required v-model="license" />

        <div class="row mt-30">
          <div class="col-12 col-md-6">
            <button
              type="button"
              class="text-link"
              :disabled="disabled"
              @click="$emit('back')"
            >
              <span class="forgot-link"> Go Back </span>
            </button>
          </div>
          <div class="col-12 col-md-6">
            <button
              type="submit"
              class="btn btn--primary mt-30"
              :disabled="disabled"
            >
              <font-awesome-icon
                v-if="disabled"
                :spin="true"
                :icon="['fas', 'spinner']"
                class="icon alt"
              />
              <span v-else>Continue</span>
            </button>
          </div>
          <div class="col-12 col-md-6 order-md-1" />
        </div>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue'
import License from '../Uploader/License.vue'
import GovernmentId from '../Uploader/GovernmentId.vue'
import Insurance from '../Uploader/Insurance.vue'

export default {

  components:{
    FormComponent,
    License,
    GovernmentId,
    Insurance,
  },
  props: {
    disabled:{
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      governmentId: null,
      insurance: null,
      license: null,
    };
  },
  methods:{
    submit(){
      if(!this.governmentId)
        return this.displayError('Select a file to upload as your goverment photo id.');
      if(!this.insurance)
        return this.displayError('Select a file to upload as your malpractice insurance.');
      if(!this.license)
        return this.displayError('Fill out all counseling license details.');

      this.$emit('submit', {
        governmentId: this.governmentId,
        insurance: this.insurance,
        license: this.license,
      })
    },
    displayError(message) {
      this.$store.commit('setGlobalAlert', {
        msg: message,
        error: true
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.top-label {
  color: $green;
  font-size: 12px;
  letter-spacing: 0.1rem;
}

</style>